import PropTypes from 'prop-types';
import React from 'react';
import {Pagination as PaginationComp} from 'react-bootstrap';
import '../../assets/css/datatable.css';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
`;

export const TotalDiv = styled.div`
  margin-right: 15px;
`;


const Pagination = ({pageCount, pageIndex, setPageIndex, total, t}) => {
  const canPreviousPage = pageIndex > 0;
  const canNextPage = pageIndex < pageCount - 1;
  const goToPage = index => () => setPageIndex(index);

  return (
    <PaginationContainer>
      <TotalDiv>
        {total} {t('totalResults')}
      </TotalDiv>
      <PaginationComp className="PaginationComp">
        {/*Previous Button*/}
        {canPreviousPage && (
          <PaginationComp.Prev
            tabIndex={pageIndex - 1}
            onClick={goToPage(pageIndex - 1)}
            className="link-next"/>
        )}

        {pageIndex >= 2 && (
          <>
            <PaginationComp.Item tabIndex={1} onClick={goToPage(0)} className="page-link-num">
            1
            </PaginationComp.Item>
            {pageIndex > 2 && <PaginationComp.Item disabled tabIndex={-1} className="ellipsis-active">...</PaginationComp.Item>}
          </>
        )}

        {canPreviousPage && (
          <PaginationComp.Item
            tabIndex={pageIndex - 1}
            onClick={goToPage(pageIndex - 1)}
            className="page-link-num"
            hidden={!canPreviousPage}>
            {pageIndex}
          </PaginationComp.Item>
        )}

        {/*Active Page*/}
        <PaginationComp.Item tabIndex={pageIndex} active>
          {pageIndex + 1}
        </PaginationComp.Item>

        {
          pageCount > pageIndex + 1 && (
            <PaginationComp.Item
              tabIndex={pageIndex + 1}
              onClick={goToPage(pageIndex + 1)}
              className="page-link-num">
              {pageIndex + 2}
            </PaginationComp.Item>
          )
        }

        {
          pageCount >= pageIndex + 3 && (
            <>
              {
                pageCount > pageIndex + 3 && <PaginationComp.Item disabled tabIndex={-1} className="ellipsis-active">...</PaginationComp.Item>
              }
              <PaginationComp.Item tabIndex={pageCount - 1} onClick={goToPage(pageCount - 1)} className="page-link-num">
                {pageCount}
              </PaginationComp.Item>
            </>
          )
        }

        {/*Next Page Button*/}
        {canNextPage && (
          <PaginationComp.Next
            tabIndex={pageIndex + 1}
            onClick={goToPage(pageIndex + 1)}
            className="link-next"/>
        )}
      </PaginationComp>
    </PaginationContainer>
  );
};

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  setPageIndex: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('common'),
)(Pagination);
